const ModalBody = (props: any) => {
  const { className = "", style = {}, children } = props;
  return (
    <div className={`modal-body ${className}`} style={style}>{children}</div>
  );
};

export default ModalBody;
